import { render, staticRenderFns } from "./SmplList.vue?vue&type=template&id=bdb0a78c&scoped=true&"
import script from "./SmplList.vue?vue&type=script&lang=js&"
export * from "./SmplList.vue?vue&type=script&lang=js&"
import style0 from "./SmplList.vue?vue&type=style&index=0&id=bdb0a78c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb0a78c",
  null
  
)

export default component.exports